import { AxiosInstance } from 'axios';
import http from '@/views/student/http';

function submitSinCtor(http: AxiosInstance) {
  return async (projectId: string, sessionId: string, form: { ssn: string }) => {
    const { data } = await http.post(`/checkout/${projectId}/${sessionId}/additional-information`, form);
    return data;
  };
}

export default submitSinCtor(http);
